var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53066 0.470058C9.67111 0.610684 9.75 0.801308 9.75 1.00006C9.75 1.19881 9.67111 1.38943 9.53066 1.53006L5.00066 6.06006L0.47066 1.53006C0.396973 1.46139 0.337871 1.3786 0.296879 1.2866C0.255887 1.1946 0.233846 1.09528 0.232069 0.994579C0.230293 0.893877 0.248817 0.793848 0.286538 0.70046C0.324258 0.607072 0.380404 0.522238 0.451622 0.451019C0.522841 0.3798 0.607675 0.323656 0.701064 0.285935C0.794452 0.248213 0.894479 0.229689 0.995183 0.231466C1.09589 0.233242 1.1952 0.255285 1.2872 0.296276C1.3792 0.337268 1.462 0.396371 1.53066 0.470058L5.00066 3.94006L8.47066 0.470058C8.61129 0.329608 8.80191 0.250718 9.00066 0.250718C9.19941 0.250718 9.39004 0.329608 9.53066 0.470058Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownLogo);
export default __webpack_public_path__ + "static/media/dropDownLogo.785c26ad1f7c529176dd77b3cf1a34cd.svg";
export { ForwardRef as ReactComponent };